export default __webpack_public_path__ + "static/media/product-mobile.c3b60d3f.jpg";